import v2_actionPesquisarProdutos from './v2_actionPesquisarProdutos';
import Actions from '../../../constants/Actions';
import { getFilialUser } from '../../../services/auth';
import { buildFilterQuery } from '../../../utils/filterOptions';

const DEFAULT_PAGE_SIZE = 60;

const buscarProdutosComFiltros = async (
    dispatch,
    { search, filters, page = 1, pageSize = DEFAULT_PAGE_SIZE, silent = false } = {}
) => {
    const loadingAction = silent ? Actions.LOADING_PRODUCTS : Actions.LOADING_PAGE;
    const loadingKey = silent ? 'loadingProducts' : 'loadingPage';
    dispatch({ type: loadingAction, [loadingKey]: true });
    try {
        const searchParam = search ? encodeURIComponent(search) : '';
        const base = `?search=${searchParam}&loja=${getFilialUser()}`;
        const filterQuery = buildFilterQuery(filters);
        const pagingQuery = `&page=${page}&pageSize=${pageSize}`;
        const querys = base + filterQuery + pagingQuery;
        const response = await v2_actionPesquisarProdutos(querys);
        if (response && response.status === 200) {
            const produtos = response.data.produtos || [];
            const total = response.data.total || 0;
            const hasMore = response.data.hasMore || false;
            const responsePage = response.data.page || page;
            const responsePageSize = response.data.pageSize || pageSize;

            dispatch({
                type: page > 1
                    ? Actions.APPEND_TODOS_PRODUTOS
                    : Actions.SET_TODOS_PRODUTOS,
                products: produtos
            });
            dispatch({
                type: Actions.SET_PRODUCTS_PAGINATION,
                productsPagination: {
                    page: responsePage,
                    pageSize: responsePageSize,
                    total,
                    hasMore
                }
            });
        }
    } catch (err) {
        console.error('Erro ao pesquisar produtos com filtros:', err);
    } finally {
        dispatch({ type: loadingAction, [loadingKey]: false });
    }
};

export default buscarProdutosComFiltros;
